import React from 'react'
import { Skeleton } from 'antd'

const SkeletonBasicDetails = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            {/* Title placeholder */}
            <Skeleton.Input
                active
                size="small"
                style={{ width: 200, height: 20, borderRadius: 4 }}
            />

            {/* Icon placeholder */}
            <Skeleton.Avatar
                active
                size="small"
                shape="circle"
                style={{ width: 24, height: 24 }}
            />
        </div>
    )
}

export default SkeletonBasicDetails
